var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageSection from '@/components/LandingPages/PageSection/PageSection';
import Testimonial from '@/components/LandingPages/Testimonial/Testimonial';
import { Card } from '@/components/ui/Card/Card';
import { Link } from '@/components/ui/Link/Link';
import { useEffect, useState } from 'react';
import { fetchCdnFile } from '../../utils/cdnFetcher';
export default function TestimonialsContainer() {
    var _this = this;
    var _a = useState([]), testimonials = _a[0], setTestimonials = _a[1];
    useEffect(function () {
        var getTestimonials = function () { return __awaiter(_this, void 0, void 0, function () {
            var testimonialList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchCdnFile('testimonials')];
                    case 1:
                        testimonialList = _a.sent();
                        setTestimonials(testimonialList);
                        return [2 /*return*/];
                }
            });
        }); };
        getTestimonials();
    }, []);
    return (_jsxs(PageSection, { backgroundClass: "bg-primary-gradient", label: "Chuffed Campaigner Trusted Testimonials", title: "A platform that stands with you", titleClass: "text-center", children: [_jsx("h3", { className: "text-center text-lg md:text-xl font-medium leading-8 md:leading-9 mb-[0.75rem] tracking-[-1px]", children: "Chuffed is a values-led platform, built for those fighting for justice, not those upholding harm, hate or bigotry" }), _jsx("h3", { className: "text-center text-lg md:text-xl font-medium leading-8 md:leading-9 mb-[2.5rem] tracking-[-1px]", children: "Neutrality won't advance social justice, but solidarity can" }), _jsx("div", { className: "grid mdl:grid-cols-3 gap-8", children: testimonials.map(function (testimonial, index) { return (_jsx(Card, { children: _jsx(Testimonial, __assign({}, testimonial)) }, "testimonial-".concat(index))); }) }), _jsx("div", { className: "w-full flex justify-center mt-[1.875rem]", children: _jsx(Link, { "aria-label": "Start a Campaign", className: "rounded-full text-white text-center font-bold text-sm xxs:text-base sm:text-lg", "data-testid": "testimonial-start-campaign", href: "/onboarding", size: "lg", variant: "secondary", children: "Start Your Campaign" }) })] }));
}
